<template>
    <div>
        <div v-show="editing">
            <sub-rating-form ref="ratingForm" :initialRating="current_rating" :ratingLegend="ratingLegend" @cancelNewRating="editing = false" @saveNewRating="editedRating"/>
        </div>
        <div v-show="!editing">
            <v-client-table ref="ratingList" :data="ratings" :columns="columns" :options="options">

                <div slot="afterFilterWrapper" class="ml-md-2 ml-0 mt-md-0 mt-2 mb-md-0 mb-3 float-md-left">
                    <div class="clearfix d-md-none d-block"></div>

                    <button type="button" class="btn btn-success" @click="showNewRating"><i class="fa fa-plus"></i> Perform New Evaluation</button>
                </div>

                <template slot="user_id" slot-scope="props">
                    <template v-if="props.row.user_id == UserId">
                        <button type="button" class="btn btn-xs btn-default" @click="editRating(props.row, props.index-1)"><i class="fa fa-edit"></i> Edit</button>
                        <button type="button" class="btn btn-xs btn-default" @click="deleteRating(props.row, props.index-1)"><span class="text-danger"><i class="fa fa-trash"></i> Delete</span></button>
                    </template>
                </template>
                <template slot="FirstName" slot-scope="props">
                    <user-name :user="props.row" />
                </template>
                <template slot="JobsiteId" slot-scope="props">
                    <router-link :to="`/jobsites/view/${props.row.JobsiteId}`">{{ props.row.JobsiteNumber }} - {{ props.row.JobsiteName }}</router-link>
                </template>
                <template slot="average_rating" slot-scope="props">
                    {{ (props.row.total_rating / props.row.max_rating * 5).toFixed(2) }} / 5 <span class="text-info">({{ (props.row.total_rating / props.row.max_rating * 100).toFixed(2) }}%)</span>
                </template>
                <template slot="future_use" slot-scope="props">
                    {{ props.row.future_use ? 'Yes' : 'No' }}
                </template>
                <template slot="created_at" slot-scope="props">
                    {{ props.row.created_at | moment('timezone', userTimezone, "MM/DD/YYYY hh:mm a") }}
                </template>
                <template slot="child_row" slot-scope="props">
                    <b-form-group label="Jobsite">
                        <router-link :to="`/jobsites/view/${props.row.JobsiteId}`">{{ props.row.JobsiteNumber }} - {{ props.row.JobsiteName }}</router-link>
                    </b-form-group>
                    <template v-for="(question,index) in props.row.ratings">
                        <b-form-group class="form-inline" :label="question.question" >
                            {{ question.rating }} / {{ question.max_rating }}
                        </b-form-group>
                    </template>
                    <b-form-group label="Recommended for future use?">
                        {{ props.row.future_use ? 'Yes' : 'No' }}
                    </b-form-group>
                    <b-form-group label="Comments">
                        {{ props.row.comments }}
                    </b-form-group>
                </template>
            </v-client-table>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            ratings: {
                type: Array,
                required: true
            },
            ratingLegend: {
                type: String,
                required: true,
                default: null,
            },
            options: {
                type: Object,
                required: false,
                default: function() {
                    return {
                        headings: {
                            user_id: 'Actions',
                            FirstName: 'User',
                            JobsiteId: 'Jobsite',
                            average_rating: 'Rating Score',
                            future_use: 'Future Use?',
                            created_at: 'Evaluation Date',
                        },
                        perPageValues: [],
                        sortable: ['user_id', 'created_at'],
                        columnsDropdown: false,
                        uniqueKey: 'sub_rating_id',
                    };
                },
            },
        },

        data: function() {
            return {
                userTimezone: this.$store.state.user.timezone,
                UserId: this.$store.state.user.user_id,
                isManager: this.$root.hasPermission('subcontractors.manage'),
                columns: ['user_id', 'FirstName', 'JobsiteId', 'average_rating', 'future_use', 'created_at'],
                editing: false,
                current_index: null,
                current_rating: null,
            }
        },

        watch: {
            ratings (newValue, oldValue){
                this.averageRating();
            },
        },

        methods: {
            averageRating() {
                if (this.ratings.length === 0)
                {
                    return;
                }

                let total_points = 0;
                let rating_points = 0;

                //Build All
                for (let i = 0; i < this.ratings.length; i++)
                {
                    total_points += +this.ratings[i].max_rating;
                    rating_points += +this.ratings[i].total_rating;
                }

                //Send it
                this.$emit('averageRating', (rating_points / total_points * 5).toFixed(2));
            },

            editRating(rating, index) {
                // The index is 1 indexed for some insane reason, we fixed it directly on the function call
                this.current_index = index;
                this.current_rating = rating;
                this.editing = true;
                this.$refs.ratingForm.setRating(rating);
            },

            editedRating(event) {
                this.$emit('editedRating', {rating: event, index: this.current_index});
                this.current_index = null;
                this.current_rating = null;
                this.editing = false;
            },

            deleteRating(rating, index){
                //Confirm it
                if(!confirm('Are you sure you want to delete this rating?'))
                {
                    return;
                }

                //Send it
                this.$http
                    .post('/subcontractors/rate/' + rating.sub_rating_id + '/delete')
                    .then(response => {
                        //Emit
                        this.$emit('ratingDeleted', {rating: event, index: index});
                    })
                    .catch(response => {

                    });
            },

            showNewRating(){
                this.$emit('showNewRating');
            }
        },

        mounted() {
            this.averageRating();
        }
    }
</script>